module.exports = require("camelcase");


//////////////////
// WEBPACK FOOTER
// external "camelcase"
// module id = 77
// module chunks = 0